//1.引入vue
import Vue from 'vue';
//2.新创建一个vue实例
let v = new Vue();
var Code = function (status) {
    //status 状态码
    console.log(status,'status')
    switch(status){
        case 101://未登录
            w_denglu();
            break;
        case 102://未认证
            w_renzheng();
            break;
        case 103://必须是企业或者实验室认证
            w_qysys();
            break;
        case 105://未设置商铺
            w_szdp();
            break;
        case 201://管理后台没有权限
           w_gly();
            break;
    }
}
var w_denglu= function (){
    
    const h = v.$createElement;
    v.$msgbox({
        title: '登录失败',
        message: h('p', null, [
            h('span', null, '登录失败请重新登录'),
        ]),
        closeOnClickModal:false,
        closeOnPressEscape:false,
        showClose:false,
        confirmButtonText: '回到登录页',
        // cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                location.reload();
                // var t = this
                localStorage.removeItem("uid")
                localStorage.removeItem("token")
                if (window.location.hash=='#/login'){
                    location.reload();
                }else {
                    location.href='user.html#/login'
                }
            } else {
                done();
            }
        }
    });
}
var w_renzheng= function (){
    const h = v.$createElement;
    v.$msgbox({
        title: '未认证',
        message: h('p', null, [
            h('span', null, '未认证,请先进入认证页进行认证'),
        ]),
        closeOnClickModal:false,
        closeOnPressEscape:false,
        showClose:false,
        confirmButtonText: '确定',
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                location.href='user.html#/account/authentication'
                done();
            } else {
                done();
            }
        }
    });
}
var w_qysys = function (){
    const h = v.$createElement;
    v.$msgbox({
        title: '提示',
        message: h('p', null, [
            h('span', null, '必须是企业或者实验室认证'),
        ]),
        closeOnClickModal:false,
        closeOnPressEscape:false,
        // showClose:false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                // location.href='user.html#/login'
                done();
            } else {
                done();
            }
        }
    });
}
var w_szdp = function (){
    const h = v.$createElement;
    v.$msgbox({
        title: '未设置商铺',
        message: h('p', null, [
            h('span', null, '未设置商铺,请先进行店铺设置'),
        ]),
        closeOnClickModal:false,
        closeOnPressEscape:false,
        // showClose:false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                location.href='user.html#/store/setups'
                done();
            } else {
                done();
            }
        }
    }).then(action => {
        v.$message({
            type: 'info',
            message: 'action: ' + action
        });
    });
}
var w_gly = function (){
    const h = v.$createElement;
    v.$msgbox({
        title: '登录失败',
        message: h('p', null, [
            h('span', null, '登录失败请重新登录'),
        ]),
        closeOnClickModal:false,
        closeOnPressEscape:false,
        showClose:false,
        confirmButtonText: '回到登录页',
        // cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                location.href='user.html#/login'
                done();
            } else {
                done();
            }
        }
    }).then(action => {
        v.$message({
            type: 'info',
            message: 'action: ' + action
        });
    });
}
export default Code;